import React from 'react';
import { ImageFile } from '~/data/types/images';

const FundingPromotionCardIcon: React.FC<ImageFile> = ({
  className,
  style,
  Component = 'svg',
}) => {
  return (
    <Component
      className={className}
      style={style}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 216 285"
    >
      <path
        d="M115.31 134.562C118.571 123.148 112.457 102.765 109.195 98.2812"
        stroke="#00D6D1"
        strokeWidth={8.15308}
        strokeLinecap="round"
      />
      <path
        d="M116.099 -136.968C229.27 34.9045 66.9253 225.371 -178.001 177.79"
        stroke="#FFE500"
        strokeWidth={17.9368}
        strokeLinecap="round"
      />
      <rect
        width={57.348}
        height={129.733}
        rx={8.97593}
        transform="matrix(0.867044 -0.446629 0.453553 0.918174 88.6836 149.414)"
        stroke="#00D6D1"
        strokeWidth={8.15308}
      />
      <path
        d="M145.068 180.867L140.004 212.168"
        stroke="#FBE64D"
        strokeWidth={5.70715}
        strokeLinecap="round"
      />
      <ellipse
        cx={4.85354}
        cy={5.1346}
        rx={4.85354}
        ry={5.1346}
        transform="matrix(0.94635 0.320846 -0.309752 0.949687 126.098 183.312)"
        fill="#FBE64D"
      />
      <ellipse
        cx={4.85354}
        cy={5.1346}
        rx={4.85354}
        ry={5.1346}
        transform="matrix(0.94635 0.320846 -0.309752 0.949687 154.635 196.359)"
        fill="#FBE64D"
      />
      <path
        d="M97.2011 89.9646L100.305 92.6249L105.542 86.4256L102.438 83.7653L97.2011 89.9646ZM108.751 140.217C110.526 141.611 113.076 141.304 114.447 139.531C115.818 137.757 115.491 135.189 113.716 133.795L108.751 140.217ZM108.529 134.881L111.012 131.67L108.529 134.881ZM87.5415 106.51C82.2404 95.8034 83.5756 89.5552 85.4712 87.3911C86.3252 86.4161 87.5853 85.8391 89.4397 86.0234C91.3982 86.218 94.0936 87.3011 97.2011 89.9646L102.438 83.7653C98.4611 80.3566 94.2467 78.2986 90.1701 77.8935C85.9893 77.4781 82.0891 78.8429 79.3578 81.9612C74.0828 87.9836 74.5474 98.5282 80.278 110.102L87.5415 106.51ZM106.046 138.092L108.751 140.217L113.716 133.795L111.012 131.67L106.046 138.092ZM80.278 110.102C86.1597 121.981 96.4997 130.591 106.046 138.092L111.012 131.67C101.389 124.11 92.4957 116.516 87.5415 106.51L80.278 110.102Z"
        fill="#00D6D1"
      />
      <ellipse
        cx={6.43737}
        cy={7.81491}
        rx={6.43737}
        ry={7.81491}
        transform="matrix(0.980335 -0.193555 0.204836 0.977699 109.678 139.086)"
        stroke="#00D6D1"
        strokeWidth={5.70715}
      />
      <path
        d="M174.494 110.648C175.25 115.658 179.065 125.678 188.281 125.678"
        stroke="#FFE500"
        strokeWidth={3.23132}
        strokeLinecap="round"
      />
      <path
        d="M174.494 136.594C173.632 132.529 169.28 124.4 158.768 124.4"
        stroke="#FFE500"
        strokeWidth={3.23132}
        strokeLinecap="round"
      />
      <path
        d="M174.494 110.508C173.632 115.14 169.28 124.403 158.768 124.403"
        stroke="#FFE500"
        strokeWidth={3.23132}
        strokeLinecap="round"
      />
      <path
        d="M174.494 136.594C175.25 132.954 179.065 125.676 188.281 125.676"
        stroke="#FFE500"
        strokeWidth={3.23132}
        strokeLinecap="round"
      />
    </Component>
  );
};

export default FundingPromotionCardIcon;
